import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react";
import { samplePages } from "../data/content";
import { SectionTitle } from "./SectionTitle";
export function SampleCarousel() {
  const [index, setIndex] = useState(0);
  if (samplePages.length === 0) return null;
  const total = samplePages.length;
  const page = samplePages[index];
  const go = (dir: number) => setIndex(i => (i + dir + total) % total);
  return <section className="bg-forest px-4 py-16 sm:px-6 sm:py-24" data-id="element-154" data-mp="2p4hzv79bbfyw">
      <SectionTitle title={<>Voici à quoi ressemblent <span className="text-gold" data-id="element-156" data-mp="2k2sotrm3b2at">les pages</span></>} subtitle="Une sélection de pages réelles du pack." data-id="element-155" data-mp="2k4dlbmrysvbb" />
      <div className="mx-auto mt-10 max-w-3xl" data-id="element-157" data-mp="2g4uxai4uk449">
        <div className="relative overflow-hidden rounded-2xl border border-moss bg-deep" data-id="element-158" data-mp="18pgpnu19z7uz">
          <AnimatePresence mode="wait" initial={false} data-id="element-159" data-mp="14n3jx5mj39y7">
            <motion.img key={page.image} src={page.image} alt={page.title} initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0
          }} transition={{
            duration: 0.18,
            ease: [0.23, 1, 0.32, 1]
          }} className="max-h-[75vh] w-full object-contain" data-id="element-160" data-mp="14ppule4pu5kn" />
          </AnimatePresence>
        </div>
        <div className="mt-5 flex items-center justify-between gap-4" data-id="element-161" data-mp="10bdr9fbxldjo">
          <button onClick={() => go(-1)} aria-label="Page précédente" className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-golddark text-gold transition-colors duration-150 hover:bg-moss" data-id="element-162" data-mp="10a2jl4fd7lna">
            <ChevronLeftIcon className="h-5 w-5" data-id="element-163" data-mp="vd2i76tgn72i" />
          </button>
          <p className="font-display text-xl font-bold text-gold" aria-live="polite" data-id="element-164" data-mp="hbztemb2zinw">
            {String(index + 1).padStart(2, "0")} / {String(total).padStart(2, "0")}
          </p>
          <button onClick={() => go(1)} aria-label="Page suivante" className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-golddark text-gold transition-colors duration-150 hover:bg-moss" data-id="element-165" data-mp="2o0s3dqozi8z2">
            <ChevronRightIcon className="h-5 w-5" data-id="element-166" data-mp="2e8w1e4js1ypk" />
          </button>
        </div>
        <h3 className="mt-4 text-center font-display text-2xl font-bold uppercase text-white" data-id="element-167" data-mp="2aaye579khmot">{page.title}</h3>
        <p className="mt-1 text-center text-white/75" data-id="element-168" data-mp="36yuty9x6kdyz">{page.caption}</p>
      </div>
    </section>;
}